import colors from '@/design/colors';
import { HeadingSmall, Text } from '@/design/typography';
import styled from 'styled-components';
import { ReactComponent as Attachment } from '@/assets/icons/attachment.svg';
import InputField from '../InputField';

export const DropzoneInput = styled(InputField)`
  display: none;
`;

export const DropzoneContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  flex-direction: column;
  gap: 8px;
`;

export const DropzoneLabel = styled.label`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  width: 100%;
  cursor: pointer;

  border-radius: 8px;
  border: 1.5px dashed ${colors.gray200};
  background: ${colors.white};
`;

export const DropzoneContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;

  padding: 16px;
`;

export const DropZoneItens = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;
`;

export const DropZoneItem = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  border-radius: 4px;
  background: ${colors.gray50};

  color: ${colors.blackAlpha200};

  /* Text 14 */
  ${HeadingSmall(14)}

  p {
    width: 80%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }

  svg {
    color: ${colors.blackAlpha200};
  }
`;

export const DropzoneIcon = styled(Attachment)`
  width: 16px;
  height: 16px;
  color: ${colors.gray200};
`;

export const DropzoneText = styled.p`
  color: ${colors.gray200};
  text-align: center;

  /* Text 14 */
  ${Text(14)}
`;
